/* ELP - hide + disable "Add to Cart" for the "Preview Lens Options" product rule only.
   Paste into: App Admin > General Settings > Custom JS.
   (injected inside a template literal, so NO backticks / NO ${ } in this code) */
(function () {
  'use strict';

  /* ---------- Config ---------- */
  var TARGET_RULE  = 'Preview Lens Options';    /* exact product-rule name to gate  */
  var HIDE         = true;                       /* true = hide+disable, false = greyed+disabled */
  var BTN_SELECTOR = '.sb_btn.sb_btn-primary';   /* the configurator primary CTA (#sb_next_btn) */
  var MARK = 'data-elp-preview-lock';

  function norm(s) { return (s == null ? '' : ('' + s)).replace(/\s+/g, ' ').trim().toLowerCase(); }

  window.__elpOrigFetch = window.__elpOrigFetch ||
    (typeof window.fetch === 'function' ? window.fetch.bind(window) : null);

  var state = 'pending'; /* pending | match | nomatch */

  function resolveFromData(data) {
    if (state !== 'pending' || !data || typeof data !== 'object') return;
    if (data.error) return; /* transient / shop-not-found -> keep polling */
    var name = data.rule_name || (data.product_rules && data.product_rules.rule_name) || '';
    if (norm(name) === norm(TARGET_RULE)) { state = 'match'; startEnforce(); }
    else { state = 'nomatch'; }
  }

  /* 1a. watch the configurator's own getProductDetails call (also catches variant re-fetch) */
  if (window.__elpOrigFetch && !window.__elpPreviewFetchPatched) {
    window.__elpPreviewFetchPatched = true;
    window.fetch = function () {
      var p = window.__elpOrigFetch.apply(window, arguments);
      try {
        var a0 = arguments[0];
        var url = (a0 && a0.url) ? a0.url : ('' + a0);
        if (url.indexOf('getProductDetails') !== -1) {
          p.then(function (res) {
            try { res.clone().json().then(resolveFromData).catch(function () {}); } catch (e) {}
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  /* 1b. fallback: if it fetched before we patched, ask once ourselves */
  function selfLookup() {
    if (state !== 'pending' || !window.__elpOrigFetch) return;
    var info = window.sb_product_info;
    var shop = (window.Shopify && window.Shopify.shop) ||
               (window.sb_shop_info && window.sb_shop_info.domain);
    if (!info || !info.id || !shop) return; /* globals not ready; poll retries */
    var q = 'product_id=' + encodeURIComponent(info.id) +
            '&product_handle=' + encodeURIComponent(info.handle || '') +
            '&product_title=' + encodeURIComponent(info.title || '') +
            '&product_type=' + encodeURIComponent(info.type || '') +
            '&product_collection_ids=' + encodeURIComponent(info.collection_ids || '') +
            '&shop=' + encodeURIComponent(shop);
    var base = 'https://www.setubridgeapps.com/prescription-eye-contact-lens/app/src/public/getProductDetails?';
    window.__elpOrigFetch(base + q, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(resolveFromData)
      .catch(function () {});
  }

  /* 2. enforce hide + disable while the button is in the Add-to-Cart state */
  var cssDone = false;
  function injectCss() {
    if (cssDone) return; cssDone = true;
    var st = document.createElement('style');
    st.setAttribute('data-elp-preview-style', '1');
    var rule = HIDE
      ? '[' + MARK + '="1"]{display:none !important;visibility:hidden !important;pointer-events:none !important;}'
      : '[' + MARK + '="1"]{opacity:.5 !important;pointer-events:none !important;cursor:not-allowed !important;}';
    st.appendChild(document.createTextNode(rule));
    (document.head || document.documentElement).appendChild(st);
  }

  function isAddToCartState(btn) {
    /* language-independent: review/summary step on screen, or button shows cart icon */
    if (document.querySelector('.sb_drawer-step[data-step="summary"]')) return true;
    if (btn && btn.querySelector('svg circle[cx="9"]')) return true;
    return false;
  }

  function enforce() {
    if (state !== 'match') return;
    var list = document.querySelectorAll(BTN_SELECTOR);
    for (var i = 0; i < list.length; i++) {
      var btn = list[i];
      if (isAddToCartState(btn)) {
        if (btn.getAttribute(MARK) !== '1') btn.setAttribute(MARK, '1');
        if (!btn.disabled) btn.disabled = true;
        if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
      } else if (btn.getAttribute(MARK) === '1') {
        /* button became "Next" again after Back -> release it */
        btn.removeAttribute(MARK);
        btn.removeAttribute('aria-disabled');
        btn.disabled = false;
      }
    }
  }

  var scheduled = false;
  function raf(cb) { if (window.requestAnimationFrame) window.requestAnimationFrame(cb); else setTimeout(cb, 16); }
  function scheduleEnforce() { if (scheduled) return; scheduled = true; raf(function () { scheduled = false; enforce(); }); }

  var enforcing = false;
  function startEnforce() {
    if (enforcing) return; enforcing = true;
    injectCss();
    enforce();
    new MutationObserver(scheduleEnforce).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest(BTN_SELECTOR) : null;
      if (t && t.getAttribute(MARK) === '1') { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
  }

  /* 3. boot: poll briefly until the rule resolves */
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (state !== 'pending' || tries > 40) { clearInterval(timer); return; }
    selfLookup();
  }, 500);
})();
